import { render, staticRenderFns } from "./GalleryDetailBannerLayout.vue?vue&type=template&id=7257ebbe&scoped=true"
import script from "./GalleryDetailBannerLayout.vue?vue&type=script&lang=js"
export * from "./GalleryDetailBannerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7257ebbe",
  null
  
)

export default component.exports